export { ReactComponent as File } from './file.svg';
export { ReactComponent as Char } from './char.svg';
export { ReactComponent as FullLogo } from './SmartFoxLogo.svg';
export { ReactComponent as FullLogoGreen } from './SmartFoxLogoGreen.svg';
export { ReactComponent as PartialLogo } from './SmartFoxLogoPartialWhite.svg';
export { ReactComponent as BoxOutlined } from './Box.svg';
export { ReactComponent as Play } from './Play.svg';
export { ReactComponent as Settings } from './Settings.svg';
export { ReactComponent as Home } from './Home.svg';
export { ReactComponent as HomePageCaption } from './HomePageCaption.svg';
export { ReactComponent as Orders } from './Orders.svg';
export { ReactComponent as Contragents } from './Contragents.svg';
export { ReactComponent as Employees } from './Employees.svg';
export { ReactComponent as Pulse } from './Pulse.svg';
export { ReactComponent as Eye } from './Eye.svg';
export { ReactComponent as Chevron } from './Chevron.svg';
export { ReactComponent as Empty } from './empty.svg';
export { ReactComponent as LeftJoin } from './LeftJoin.svg';
export { ReactComponent as InnerJoin } from './InnerJoin.svg';
export { ReactComponent as Patch } from './patch.svg';
export { ReactComponent as Star } from './Star.svg';
export { ReactComponent as ThreeDots } from './ThreeDots.svg';
export { ReactComponent as Plus } from './Plus.svg';
export { ReactComponent as Minus } from './Minus.svg';
export { ReactComponent as Download } from './Download.svg';
